import React from "react";
// import classes from "../assets/styles/PageComponentsStyles/Settings/SubscriptionIndividual.module.css";
import { COUPON_APPLY, PACKAGES_LISTING } from "../utils/constants/apiUrl";
import { get, post } from "../server";
import {
  loggedInUser,
  subscribedPackage,
  teamIDCheck,
  userIDCheck,
} from "../utils/store";
import { useAtom } from "jotai";
import Loader from "../components/Loader";
import { useEffect } from "react";
import { useState } from "react";
import showToast from "../helpers/showToast";
import { loadStripe } from "@stripe/stripe-js";
import SubscriptionModal from "../components/Modals/SubscriptionModal";
import { Link, useLocation, useNavigate } from "react-router-dom";
import useLogout from "../hooks/useLogout";
import { AiFillCheckCircle } from "react-icons/ai";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import basicicon from "../assets/images/settings_page_icons/basicicon.png";
import proicon from "../assets/images/settings_page_icons/proicon.png";
import premiumicon from "../assets/images/settings_page_icons/premiumicon.png";
import { trackEvent } from "../utils/mixpanel";
import { Button, Card, Modal, Nav, Row } from "react-bootstrap";
import SubscriptionCard from "../components/SubscriptionCard";
import {
  elementsOptions,
  stripePromise,
} from "../utils/constants/stripeConfig";

const SubscriptionIndividual = () => {
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedPackage, setSelectedPackage] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [purchasedPackage, setPurchasedPackage] = useAtom(subscribedPackage);
  // const [personalAccount, setPersonalAccount] = useAtom(accountType);
  // const [isOwnerPackageActive, setIsOwnerPackageActive] =
  //   useAtom(isOwnerPackage);
  const [userTeamId, setUserTeamId] = useAtom(teamIDCheck);
  const [userID, setUserID] = useAtom(userIDCheck);
  const [activeKeys, setActiveKeys] = useState([]);
  const [selectedSubscriptionType, setSelectedSubscriptionType] = useState();
  const [activeTab, setActiveTab] = useState("monthly");
  const [hasCouponMonthly, setHasCouponMonthly] = useState([]);
  const [hasCouponYearly, setHasCouponYearly] = useState([]);
  const [couponCode, setCouponCode] = useState("");
  const [blankCouponField, setBlankCouponField] = useState(false);
  const [correctCouponEntered, setCorrectCouponEntered] = useState(false);
  const [incorrectCouponEntered, setIncorrectCouponEntered] = useState(false);
  const [couponMessage, setCouponMessage] = useState("");
  const [couponData, setCouponData] = useState("");
  const creationDate = new Date(purchasedPackage?.end_date);
  const currentDate = new Date();
  const isExpired = creationDate < currentDate;
  const [hasCoupon, setHasCoupon] = useState(
    loggedUser?.coupon?.is_payable || false
  );
  const [couponDetails, setCouponDetails] = useState(loggedUser?.coupon || "");
  const [couponReedemed, setCouponReedemed] = useState(
    loggedUser?.coupon?.discount === 100 ? true : false
  );

  const handleCloseCouponModal = () => {
    setHasCoupon(false);
    setCouponReedemed(false);
  };
  // const location = useLocation();
  const logout = useLogout();
  const navigate = useNavigate();

  const handleTabSelect = (subscriptionIndex, key) => {
    setActiveKeys((prevActiveKeys) => {
      // Create a copy of the previous activeKeys array
      const updatedActiveKeys = [...prevActiveKeys];
      // Update the active key for the corresponding subscription
      updatedActiveKeys[subscriptionIndex] = key;
      return updatedActiveKeys;
    });
  };

  const handleCheckboxChangeMonthly = (index) => {
    setHasCouponMonthly((prev) => {
      const updated = [...prev];
      updated[index] = !updated[index];
      return updated;
    });
  };

  const handleCheckboxChangeYearly = (index) => {
    setHasCouponYearly((prev) => {
      const updated = [...prev];
      updated[index] = !updated[index];
      return updated;
    });
  };

  // Handle Logout
  const handleLogout = () => {
    logout();
  };
  useEffect(() => {
    setCorrectCouponEntered(false);
    setIncorrectCouponEntered(false);
  }, [activeKeys]);
  const applyCoupon = async (subscriptionType, packageId) => {
    if (!couponCode) {
      setBlankCouponField(true);
      return;
    }
    // setLoading(true);
    setCorrectCouponEntered(false);
    setIncorrectCouponEntered(false);

    const payload = {
      package_id: packageId,
      coupon_code: couponCode,
      subscription_type: subscriptionType,
    };
    let { status, message, data } = await post(
      COUPON_APPLY,
      payload,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );

    if (status) {
      setCorrectCouponEntered(true);
      setCouponData(data);
      setCouponMessage(message);
    } else {
      setIncorrectCouponEntered(true);
      setCouponMessage(message);
    }
  };

  // Load singlePackage data
  const loadSubscriptions = async () => {
    setLoading(true);
    const queryString = `?user_id=${loggedUser?.id}&team_id=${userTeamId}`;
    let { status, message, data } = await get(
      PACKAGES_LISTING + queryString,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );

    if (status) {
      if (data) {
        let ownerpackages = data.filter(
          (singlePackage) => singlePackage.package_type === "personal"
        );
        setSubscriptions(ownerpackages);
      }
    } else {
      showToast(status, message);
    }
    setLoading(false);
  };

  useEffect(() => {
    loadSubscriptions();
  }, []);

  if (loading) {
    return <Loader />;
  }
  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handlePayment = async (obj, subscription_type) => {
    setSelectedPackage(obj);
    setSelectedSubscriptionType(subscription_type);
    setShowModal(true);
  };

  // const checkExpire = () => {
  //   let isTeamPackage = loggedUser?.package_details.filter(
  //     (obj) => obj.team_id == loggedUser?.teams.id
  //   );

  //   let endDate = new Date(isTeamPackage[0]?.end_date);
  //   let todayDate = new Date();

  //   if (todayDate >= endDate) return false;
  //   return true;
  // };

  return (
    <>
      <div className="container-fluid p-5">
        <div className="d-flex flex-md-row flex-column align-items-center justify-content-between mb-5">
          {/* <div className={classes.skipBtnWrapper}> */}
          <Button variant="primary" onClick={handleLogout}>
            Logout
          </Button>
          {/* </div> */}
          <div className="heading">
            <h1 className="mb-0">Packages</h1>
          </div>
          {/* <div className={classes.skipBtnWrapper}> */}
          <Button variant="primary" onClick={() => navigate("/")}>
            Go Back
          </Button>
          {/* </div> */}
        </div>
        <div className="row g-4">
          <div className="col-12">
            <Tab.Container
              activeKey={activeTab}
              onSelect={(k) => setActiveTab(k)}
            >
              <Nav variant="tabs" className="mb-3">
                <Nav.Item>
                  <Nav.Link eventKey="monthly">Monthly</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="yearly">Yearly</Nav.Link>
                </Nav.Item>
                {/* <Nav.Item>
                  <Nav.Link eventKey="customer_specific_personal">
                    Custom
                  </Nav.Link>
                </Nav.Item> */}
              </Nav>

              {/* <Tab.Content>
                {["monthly", "yearly", "customer_specific_personal"].map(
                  (type) => (
                    <Tab.Pane eventKey={type} key={type}>
                      {console.log("type", type)}
                      <Row className="g-4">
                        {subscriptions
                          // .filter(
                          //   (opt) =>
                          //     opt.package_type === "personal"
                          //   // || opt.package_type === "customer_specific_personal"
                          // )
                          .filter((opt) =>
                            opt.package_type === "customer_specific_personal"
                              ? "customer_specific_personal"
                              : opt.package_type === "personal"
                              ? "personal"
                              : ""
                          )
                          .map((singlePackage, index) => (
                            <>
                              {console.log("singlePackage", singlePackage)}
                              <SubscriptionCard
                                key={index}
                                index={index}
                                singlePackage={singlePackage}
                                purchasedPackage={purchasedPackage}
                                // isExpired={isExpired}
                                subscriptionType={type}
                                isCouponChecked={
                                  type === "monthly"
                                    ? hasCouponMonthly[index]
                                    : hasCouponYearly[index]
                                }
                                couponCode={couponCode}
                                onCheckboxChange={
                                  type === "monthly"
                                    ? handleCheckboxChangeMonthly
                                    : handleCheckboxChangeYearly
                                }
                                onCouponChange={setCouponCode}
                                onApplyCoupon={applyCoupon}
                                onSelectPlan={handlePayment}
                                // onCancelSubscription={handleCancelSubscription}
                                incorrectCouponEntered={incorrectCouponEntered}
                                correctCouponEntered={correctCouponEntered}
                                couponData={couponData}
                                setCouponData={setCouponData}
                                blankCouponField={blankCouponField}
                                setBlankCouponField={setBlankCouponField}
                                couponMessage={couponMessage}
                              />
                            </>
                          ))}
                      </Row>
                    </Tab.Pane>
                  )
                )}
              </Tab.Content> */}
              <Tab.Content>
                {["monthly", "yearly", "customer_specific_personal"].map(
                  (type) => (
                    <Tab.Pane eventKey={type} key={type}>
                      <Row className="row g-4">
                        {subscriptions
                          .filter((opt) => {
                            if (type === "monthly") {
                              return (
                                (opt.package_type === "personal" &&
                                  (Number(opt.price_monthly) > 0 ||
                                    opt.package_name === "Starter" ||
                                    opt.package_name === "Enterprise")) ||
                                opt.package_type ===
                                  "customer_specific_personal"
                              );
                            }
                            if (type === "yearly") {
                              return (
                                (opt.package_type === "personal" &&
                                  (Number(opt.price_yearly) > 0 ||
                                    opt.package_name === "Starter" ||
                                    opt.package_name === "Enterprise")) ||
                                opt.package_type ===
                                  "customer_specific_personal"
                              );
                            }
                            if (type === "customer_specific_personal") {
                              return (
                                opt.package_type ===
                                "customer_specific_personal"
                              );
                            }
                            return false;
                          })
                          .map((singlePackage, index) => (
                            // <SubscriptionCard
                            //   key={index}
                            //   index={index}
                            //   singlePackage={singlePackage}
                            //   purchasedPackage={purchasedPackage}
                            //   isExpired={isExpired}
                            //   subscriptionType={type}
                            //   isCouponChecked={
                            //     type === "monthly"
                            //       ? hasCouponMonthly[index]
                            //       : hasCouponYearly[index]
                            //   }
                            //   couponCode={couponCode}
                            //   onCheckboxChange={
                            //     type === "monthly"
                            //       ? handleCheckboxChangeMonthly
                            //       : handleCheckboxChangeYearly
                            //   }
                            //   onCouponChange={setCouponCode}
                            //   onApplyCoupon={applyCoupon}
                            //   onSelectPlan={handlePayment}
                            //   // onCancelSubscription={handleCancelSubscription}
                            //   incorrectCouponEntered={incorrectCouponEntered}
                            //   correctCouponEntered={correctCouponEntered}
                            //   couponData={couponData}
                            //   setCouponData={setCouponData}
                            //   blankCouponField={blankCouponField}
                            //   setBlankCouponField={setBlankCouponField}
                            //   couponMessage={couponMessage}
                            // />
                            <SubscriptionCard
                              key={index}
                              index={index}
                              singlePackage={singlePackage}
                              purchasedPackage={purchasedPackage}
                              isExpired={isExpired}
                              subscriptionType={type}
                              isCouponChecked={
                                type === "monthly"
                                  ? hasCouponMonthly[index]
                                  : hasCouponYearly[index]
                              }
                              couponCode={couponCode}
                              onCheckboxChange={
                                type === "monthly"
                                  ? handleCheckboxChangeMonthly
                                  : handleCheckboxChangeYearly
                              }
                              onCouponChange={setCouponCode}
                              onApplyCoupon={applyCoupon}
                              onSelectPlan={handlePayment}
                              // onCancelSubscription={handleCancelSubscription}
                              incorrectCouponEntered={incorrectCouponEntered}
                              correctCouponEntered={correctCouponEntered}
                              couponData={couponData}
                              setCouponData={setCouponData}
                              blankCouponField={blankCouponField}
                              setBlankCouponField={setBlankCouponField}
                              couponMessage={couponMessage}
                              // purchasedPackageData={purchasedPackageData}
                            />
                          ))}
                      </Row>
                    </Tab.Pane>
                  )
                )}
              </Tab.Content>
            </Tab.Container>
          </div>
        </div>
      </div>
      {showModal && (
        <SubscriptionModal
          show={showModal}
          stripePromise={stripePromise}
          handleCloseModal={handleCloseModal}
          selectedPackage={selectedPackage}
          selectedSubscriptionType={selectedSubscriptionType}
          elementsOptions={elementsOptions}
        />
      )}

      <Modal
        show={hasCoupon}
        onHide={handleCloseCouponModal}
        aria-labelledby="contained-modal-title-vcenter"
        className="customModal"
      >
        <Modal.Body
          className={`d-flex justify-content-center flex-column align-items-center py-4`}
        >
          <div className="public-coupon-page">
            <div className="container h-100">
              <div className="row justify-content-center align-items-center h-100">
                <div className="col-12 text-center">
                  {/* <Card className=" text-center">
                        <Card.Body> */}
                  {/* <img
                            src={logo}
                            alt=""
                            className="d-block mx-auto logo"
                          /> */}
                  <img
                    src="/images/surprise-red-gift-box.png"
                    alt=""
                    className="d-block mx-auto"
                  />
                  <h1>Surprise!</h1>
                  <p className="subtitle">Your special gift is waiting.</p>
                  <p className="package-text">
                    {/* Your{" "}
                            <span className="pkg-name">
                              {couponDetails?.package?.package_name}
                            </span>{" "}
                            {couponDetails?.duration_type} Package Is{" "}
                            <span className="pkg-val">
                              {couponDetails?.discount === 100
                                ? "Completely FREE"
                                : `${couponDetails?.discount}% Off`}
                            </span> */}
                    You Have Get{" "}
                    <span className="pkg-val">{couponDetails?.discount}%</span>{" "}
                    Off on{" "}
                    <span className="pkg-name">
                      {couponDetails?.package_name}
                    </span>{" "}
                    {couponDetails?.duration_type} package!
                  </p>
                  {/* <h1>
                            You Have Get {couponDetails?.discount}% Off on{" "}
                            {couponDetails?.package_name}{" "}
                            {couponDetails?.duration_type} package!
                          </h1> */}
                  <p>
                    To avail this offer, please use the coupon code below during
                    the package purchase.
                  </p>
                  {/* <div className="coupon-code-wrapper">
                            {`${couponDetails?.coupon_code?.coupon}`}
                          </div> */}
                  <div className="coupon-code-wrapper">
                    {`${couponDetails?.coupon_code?.coupon}`}
                    <img src="/images/scissors.png" alt="" className="" />
                  </div>
                  <Button
                    variant="primary"
                    onClick={() => navigate(`/packages`)}
                    className="rounded-pill mb-3"
                  >
                    Go to Package
                  </Button>
                  <Button
                    variant="outline-dark"
                    onClick={() => navigate(`/packages`)}
                    className="rounded-pill"
                  >
                    Close
                  </Button>
                  {/* </Card.Body>
                      </Card> */}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={couponReedemed}
        onHide={handleCloseCouponModal}
        aria-labelledby="contained-modal-title-vcenter"
        className="customModal"
      >
        <Modal.Body
          className={`d-flex justify-content-center flex-column align-items-center`}
        >
          <div className="public-coupon-page">
            <div className="container">
              <div className="row justify-content-center align-items-center">
                <div className="col-12">
                  <Card className=" text-center">
                    <Card.Body>
                      <h1>Coupon Redeemed Successfully!</h1>
                      <p className="mb-4">
                        You’ve successfully applied your coupon code. Enjoy your
                        exclusive discount on the {couponDetails?.package_name}{" "}
                        {couponDetails?.duration_type} package.
                      </p>
                      {/* <div className="coupon-code-wrapper">
                        {`${couponDetails?.coupon_code?.coupon}`}
                      </div> */}
                      <Button
                        variant="outline-primary"
                        className="me-3"
                        onClick={handleCloseCouponModal}
                      >
                        Close
                      </Button>
                      <Button
                        variant="outline-primary"
                        className="me-3"
                        onClick={() => navigate(`/`)}
                      >
                        Go to Home
                      </Button>
                    </Card.Body>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SubscriptionIndividual;
